import { render, staticRenderFns } from "./CalSceneSegmentSceneRela.vue?vue&type=template&id=735e5f52"
import script from "./CalSceneSegmentSceneRela.vue?vue&type=script&lang=js"
export * from "./CalSceneSegmentSceneRela.vue?vue&type=script&lang=js"
import style0 from "./CalSceneSegmentSceneRela.vue?vue&type=style&index=0&id=735e5f52&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports